import axiosInstance from "../../utils/config/config";

export const getAboutMe = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAboutMeRequest",
    });
    const { data } = await axiosInstance.get(`/aboutMe/get`);
    dispatch({
      type: "getAboutMeSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "getAboutMeFailure",
      payload: true,
    });
  }
};
